
import { IRegionState } from './region-state';


export interface IRegion {
  readonly id: number;
  state?: string;
  name?: string;
  additionalPovertyGuidline?: number;
  modifyDate?: Date | string;
  regionStates?: IRegionState[];
}
